import { telegram } from "@/shared/lib/telegram"

import { TOURNAMENT_NOMINATIONS_TELEGRAM_URL } from "./constants"

export function openTournamentNominationsPost(): void {
  telegram.openTelegramLink(TOURNAMENT_NOMINATIONS_TELEGRAM_URL)
}
